import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MatchRing } from "@/components/MatchRing";
import { StatusBadge } from "@/components/StatusBadge";

export const MyApplications = () => {
  const [apps, setApps] = useState([]);

  useEffect(() => {
    api.get("/applications/mine").then((r) => setApps(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 py-10">
      <div className="mono-label">applications</div>
      <h1 className="font-display text-3xl font-semibold tracking-tight mt-2">Your applications</h1>

      <div className="mt-8 space-y-3">
        {apps.map((a) => (
          <Link
            key={a.application_id}
            to={a.job ? `/jobs/${a.job_id}` : "#"}
            className="border border-white/10 bg-[#111827] rounded-xl p-5 hover:border-white/20 transition-colors flex items-center gap-5"
            data-testid={`app-row-${a.application_id}`}
          >
            <MatchRing value={a.match?.overall || 0} size={64} stroke={6} />
            <div className="flex-1">
              <div className="font-display text-lg font-medium">{a.job?.title || "Job removed"}</div>
              <div className="text-sm text-slate-400 mt-1">{a.job?.company} · {a.job?.location}</div>
              <div className="text-xs text-slate-500 mt-2 line-clamp-1">{a.match?.summary}</div>
            </div>
            <div className="mono-label text-slate-400 shrink-0"><StatusBadge status={a.status || "submitted"} /></div>
          </Link>
        ))}
        {apps.length === 0 && (
          <div className="text-slate-500 text-sm border border-dashed border-white/10 rounded-xl p-10 text-center">
            You haven't applied to any jobs yet.{" "}
            <Link to="/jobs" className="text-[#06B6D4] hover:underline">Browse open roles</Link>
          </div>
        )}
      </div>
    </div>
  );
};
